import React, {useEffect} from "react";
import {Toast} from "react-bootstrap";

import "./AppToast.css"
import {CircleAlert, CircleCheck, CircleX, TriangleAlert, X} from "lucide-react";
import {TOAST_DELAY, useNotifications, useNotificationsState} from "../../context/NotificationContext.jsx";

const VARIANTS = {
    success: {header: "Success", className: "toast-success", Icon: CircleCheck},
    warning: {header: "Info", className: "toast-warning", Icon: TriangleAlert},
    info: {header: "Info", className: "toast-info", Icon: CircleAlert},
    error: {header: "Error", className: "toast-error", Icon: CircleX},
}

export default function AppToast() {
    const { toasts } = useNotificationsState();
    const { hideToast, dismissToast, removeToast, openToastInPanel } = useNotifications();

    const toast = toasts ? toasts[0] : null;
    const { className, Icon } = VARIANTS[toast?.type] ?? VARIANTS.info;

    // Own timer instead of Toast's autohide, which can't be restarted: each repeat (count change)
    // gives the toast a fresh TOAST_DELAY.
    useEffect(() => {
        if (!toast?.show) return;
        const timer = setTimeout(() => hideToast(toast.id), TOAST_DELAY);
        return () => clearTimeout(timer);
    }, [toast?.id, toast?.show, toast?.count, hideToast]);

    return toast ? (
        <Toast
            key={toast.id}
            className={`app-toast ${className}`}
            show={toast.show}
            onExited={() => removeToast(toast.id)}
        >
            <Icon className="toast-icon" size={28}/>
            {/* Long messages are cut to two lines; the full text is in the bell's dropdown. */}
            <button
                type="button"
                className="app-toast-body"
                title="Show in notifications"
                onClick={() => openToastInPanel(toast.id)}
            >
                <p>{toast.message}</p>
            </button>
            {toast.count > 1 && <span className="toast-count">×{toast.count}</span>}
            <button type="button" className="toast-close" aria-label="Close" onClick={() => dismissToast(toast.id)}>
                <X size={20}/>
            </button>
        </Toast>
    ) : null
}
